'use client';

import * as React from 'react';
import Link from 'next/link';
import type { CultivCopy } from '../types';
import { MARKETING_CDN, demoHref, cultivPath, blogHref, careersHref, loginHref } from '../site';

export function SiteFooter({ copy, locale }: { copy: CultivCopy; locale: string }) {
  const common = copy.common;
  const tagLines = common.footTag.split('\n');
  const base = cultivPath(locale);

  return (
    <footer className="b-footer">
      <div className="b-footer-top">
        <div>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img className="b-footer-logo" src={`${MARKETING_CDN}/cultiv-lockup-offwhite.svg`} alt="Cultiv" />
          <div className="b-footer-tag">
            {tagLines.map((line, i) => (
              <React.Fragment key={i}>{i > 0 && <br />}{line}</React.Fragment>
            ))}
          </div>
        </div>
        <div className="b-footer-col">
          <h6>{common.footProducts}</h6>
          {copy.home.tabs.map((tab, i) => (
            <Link key={i} href={`${base}/platform#pillar-${i}`}>{tab.label}</Link>
          ))}
        </div>
        <div className="b-footer-col">
          <h6>{common.footCompany}</h6>
          <Link href={`${base}/customers`}>{common.footCustomers}</Link>
          <Link href={blogHref(locale)}>{common.footBlog}</Link>
          <Link href={careersHref(locale)}>{common.footCareers}</Link>
          <a href={loginHref(locale)}>{common.footLogin}</a>
        </div>
        <div className="b-footer-col">
          <h6>{common.footContact}</h6>
          <Link href={demoHref(locale)}>{common.footDemo}</Link>
          <a href="mailto:hello@cultiv.immo">hello@cultiv.immo</a>
        </div>
      </div>
      <div className="b-footer-bottom">
        <span>{common.bottomRights}</span>
        <Link href={`${base}/privacy-policy`}>{common.footPrivacy}</Link>
      </div>
    </footer>
  );
}
